import styled from 'styled-components';
import tw from 'twin.macro';

export const ErrorMessage = styled.span`
  ${tw`text-xs mt-1 text-red-600 font-normal leading-4`}
`;

export const LimitedSeatMessageContainer = styled.div`
  ${tw`flex flex-row items-center gap-4px h-5 mb-16px p-0 flex-nowrap `};
  width: 175px;
`;

export const LimitedSeatMessageText = styled.span`
  ${tw`text-orange-600 font-inter font-medium text-14px leading-5`}
`;

export const TnCText = styled.p`
  font-family: HKGrotesk;
  font-stretch: normal;
  font-style: normal;
  line-height: 1rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: rgba(71, 85, 105);
  margin-top: 0.5rem;
`;

export const AdditionalCTAButton = styled.button`
  ${tw`px-24px py-8px rounded-10px bg-transparent text-blue-600 flex justify-center items-center text-14px outline-none mt-1`};
`;

export const ExtraFooterUIContainer = styled.div`
  ${tw`flex flex-row justify-between items-stretch gap-16px w-full self-stretch`}
`;

export const LimitedTimeOfferContainer = styled.div`
  ${tw`flex flex-col gap-10px justify-end flex-1`}

  @media (max-width: 768px) {
    display: none;
  }
`;

export const CTAAndSubmitButtonContainer = styled.div`
  ${tw`flex flex-col justify-center items-center gap-12px flex-1`}
`;

export const PriceContainer = styled.div`
  ${tw`flex flex-row items-center gap-4px self-stretch`}
  font-size: 24px;

  .free-plan-offer {
    font-family: 'Satoshi Variable', sans-serif;
    font-weight: 700;
    color: #8b5cf6;
  }

  .striked-amount {
    font-family: 'Satoshi Variable', sans-serif;
    font-weight: 500;
    color: #f5f3ff;
    opacity: 0.5;
    text-decoration: line-through;
  }
`;
